<template>
	<div>
		<NuxtLayout>
			<NuxtPage/>
		</NuxtLayout>
		 <Toast/>
	</div>
</template>
<script setup lang="ts">
import Toast from "~/components/toast.vue";
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

// HTML lang 속성을 동적으로 업데이트
useHead({
  htmlAttrs: {
    lang: computed(() => locale.value)
  }
})
</script>